import { to as tos } from 'await-to-js'
import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'

NProgress.configure({ showSpinner: false })
export const whiteList = ['/login', '/register', '/index', '/techConsult', '/deviceShare', '/', '/401', '/404']

// 官网首页（http://www.fjnhcxyjy.com/）
// 共享平台（http://gxpt.fjnhcxyjy.com/）
// 科技咨询（http://kjzx.fjnhcxyjy.com/）
// 路由守卫，根据域名判断并导航到对应页面
router.beforeEach((to, from, next) => {
  const hostname = window.location.hostname;
  const currentPath = window.location.pathname;

  if (currentPath === '/' || currentPath === '') {
    if (hostname === 'gxpt.fjnhcxyjy.com') {
      if (to.name !== 'deviceShare') {
        next({ name: 'deviceShare' });
      } else {
        next()
      }
    } else if (hostname === 'kjzx.fjnhcxyjy.com') {
      if (to.name !== 'techConsult') {
        next({ name: 'techConsult' });
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
});

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (getToken()) {
    to.meta.title && useSettingsStore().setTitle(to.meta.title as string)
    /* has token*/
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else if (whiteList.indexOf(to.path) !== -1) {
      const [err] = await tos(useUserStore().getInfo())
      if (err) {
        await useUserStore().logout()
      } else {
        next()
      }
      next()
    } else {
      if (useUserStore().roles.length === 0) {
        isRelogin.show = true
        // 判断当前用户是否已拉取完user_info信息
        const [err] = await tos(useUserStore().getInfo())
        if (err) {
          await useUserStore().logout()
        } else {
          next()
        }
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
